export default __webpack_public_path__ + "static/media/Info_Entregado.6fc8ede0.png";